import { apiConfig } from '../api-config';

interface AppointmentData {
  agentId: string;
  territoryId: string;
  appointmentType: string;
  tokenKey: string;
  url: string;
  idUser: 0;
}

export const insertAppointment = (params: AppointmentData) => {
  const uri = 'api/appointments/create';
  return apiConfig.post(`${uri}`, params, {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    },
  });
};
